import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

const CAN_USE_DOM = typeof window !== 'undefined';

if (CAN_USE_DOM) {
  window.dataLayer = window.dataLayer || [];
}

function gtag(...args: unknown[]) {
  if (CAN_USE_DOM) {
    window.dataLayer.push(args);
  }
}

if (CAN_USE_DOM) {
  window.gtag = gtag;
}

function install(id: string) {
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(script);
}

interface IGoogleProps {
  trackingId: string;
}

export const Google = (props: IGoogleProps) => {
  const location = useLocation();

  useEffect(() => {
    const handleLocationChange = (pathname: string) => {
      gtag('config', props.trackingId, { page_path: pathname });
    };

    handleLocationChange(location.pathname);

    if (CAN_USE_DOM) {
      install(props.trackingId);
      gtag('js', new Date());
      gtag('config', props.trackingId);
    }

    return () => {
      handleLocationChange(location.pathname);
    };
  }, [props.trackingId, location]);

  return null;
};
